import { AccordionGeneralityForm as GeneralityVM } from 'shell/view-models/accordion-generality-form';
import { Generality } from 'shell/models/person/generality';
import { AccordionPersonForm } from 'shell/view-models/accordion-person-form';
import { AccordionEditDataControl } from 'shell/view-models/edit-data-control';

export const transformGenerality = (
  generality?: GeneralityVM | null,
  person?: AccordionPersonForm | null,
  editDataControl?: AccordionEditDataControl
): Generality | null => {
  const withComune = Boolean(
    generality?.italian?.municipality?.description || generality?.italian?.province
  );

  const withLocalita = Boolean(
    generality?.foreign?.municipality?.description ||
      generality?.foreign?.state?.value ||
      generality?.foreign?.state?.id ||
      generality?.foreign?.province ||
      generality?.foreign?.state?.province
  );

  const generalityKeys = generality
    ? Object.keys(generality).filter((el) => !!generality[el as keyof GeneralityVM]).length > 0
    : false;

  const personKeys = person
    ? Object.keys(person).filter((el) => !!person[el as keyof AccordionPersonForm]).length > 0
    : false;

  const originReturnData: Generality | null =
    generalityKeys || personKeys || withComune || withLocalita
      ? {
          annoEspatrio:
            generality?.aire !== 'N' ? generality?.expatriationYear || undefined : undefined,
          codiceFiscale: person?.fiscalCode
            ? {
                codFiscale:
                  editDataControl?.flag === '1' ? undefined : person?.fiscalCode || undefined,
                validitaCF: generality?.validityFiscalCodeId || undefined,
                dataAttribuzioneValidita:
                  generality?.validityDateFiscalCode?.toFormat('yyyy-MM-dd') || undefined,
              }
            : undefined,
          nome: person?.name || undefined,
          cognome: person?.surname || undefined,
          senzaCognome: person?.withoutSurname ? '1' : undefined,
          senzaNome: person?.withoutName ? '1' : undefined,
          sesso: generality?.gender || undefined,
          dataNascita: generality?.birthDate?.toFormat('yyyy-MM-dd') || undefined,
          senzaGiorno:
            generality?.birthDate &&
            !generality?.birthChoiceDate?.includes('day') &&
            generality?.birthChoiceDate?.includes('month')
              ? '1'
              : undefined,
          senzaGiornoMese:
            generality?.birthDate &&
            !generality?.birthChoiceDate?.includes('day') &&
            !generality?.birthChoiceDate?.includes('month')
              ? '1'
              : undefined,
          luogoNascita:
            withComune || withLocalita || generality?.exceptionalBirthPlace
              ? {
                  luogoEccezionale: generality?.exceptionalBirthPlace || undefined,
                  comune: withComune
                    ? {
                        nomeComune: generality?.italian?.municipality?.description || undefined,
                        codiceIstat: generality?.italian?.municipality?.id || undefined,
                        siglaProvinciaIstat:
                          generality?.italian?.municipality?.province || undefined,
                      }
                    : undefined,
                  localita: withLocalita
                    ? {
                        descrizioneLocalita:
                          generality?.foreign?.municipality?.description || undefined,
                        descrizioneStato: generality?.foreign?.state?.value || undefined,
                        codiceStato: generality?.foreign?.state?.id || undefined,
                        codice:
                          generality?.foreign?.municipality?.el?.key?.codice?.toString() ||
                          undefined,
                        provinciaContea: generality?.foreign?.state?.province || undefined,
                      }
                    : undefined,
                }
              : undefined,
          soggettoAIRE: generality?.aire || undefined,
          idSchedaSoggettoComune:
            generality?.istatCode || generality?.municipalityIdentifier
              ? {
                  idSchedaSoggettoComuneIstat: generality?.istatCode || undefined,
                  idSchedaSoggetto: generality?.municipalityIdentifier || undefined,
                }
              : undefined,
          idSchedaSoggettoANPR: generality?.anprIdentifier || undefined,
          note: generality?.note || undefined,
        }
      : null;

  return originReturnData;
};
